import { Box, CircularProgress, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import {
  ONBOARDING_AI_SPARKLE_ICON_SRC,
  ONBOARDING_AI_SPARKLE_ICON_SRC_2X,
  OnboardingRetinaImage,
} from '../onboardingAssets';
import { ONBOARDING_STEP2_FIGMA, ONBOARDING_STEP6_FIGMA } from '../onboardingFigmaSpec';

/** Figma — building training plan loading state with spinner, AI sparkle, and message. */
export function OnboardingStepLoading() {
  const { t } = useTranslation();
  const { typography, colors } = ONBOARDING_STEP2_FIGMA;
  const { loading } = ONBOARDING_STEP6_FIGMA;

  return (
    <Box
      role="status"
      aria-live="polite"
      aria-busy="true"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: `${loading.spinnerGap}px`,
        height: '100%',
        minHeight: ONBOARDING_STEP6_FIGMA.complete.contentViewportHeight,
        backgroundColor: 'var(--lens-semantic-color-surface-default)',
      }}
    >
      <CircularProgress size={loading.spinnerSize} sx={{ color: colors.typeDefault }} aria-hidden />

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: `${loading.contentGap}px`,
          maxWidth: loading.blockMaxWidth,
          px: 2,
          textAlign: 'center',
        }}
      >
        <Box
          sx={{
            display: 'inline-flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            gap: `${loading.messageGap}px`,
            maxWidth: '100%',
          }}
        >
          <OnboardingRetinaImage
            src={ONBOARDING_AI_SPARKLE_ICON_SRC}
            src2x={ONBOARDING_AI_SPARKLE_ICON_SRC_2X}
            width={24}
            height={24}
          />
          <Typography
            component="p"
            sx={{
              m: 0,
              fontSize: loading.title.fontSize,
              fontWeight: loading.title.fontWeight,
              lineHeight: `${loading.title.lineHeight}px`,
              color: colors.typeDefault,
              whiteSpace: 'nowrap',
            }}
          >
            {t('onboarding.wizard.step7.loading_title')}
          </Typography>
        </Box>

        <Typography
          sx={{
            m: 0,
            maxWidth: 275,
            fontSize: typography.body.fontSize,
            fontWeight: typography.body.fontWeight,
            lineHeight: `${typography.body.lineHeight}px`,
            letterSpacing: typography.body.letterSpacing,
            color: colors.typeDefault,
          }}
        >
          {t('onboarding.wizard.step7.loading_subtitle')}
        </Typography>
      </Box>
    </Box>
  );
}
